import React, {FunctionComponent, useState} from "react";
import {makeStyles} from "tss-react/mui";
import {Button, Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Tooltip,} from "@mui/material";
import MuiSelect from "@mui/material/Select";
import { useAppSelector } from "@/Redux/Redux";
import { RootStateOrAny, useSelector } from "react-redux";
import {
    selectViewerEnabledRegions,
    selectViewerEnabledStations,
    ViewerState,
} from "@/Redux/Auth/AuthReducer";
import _ from "lodash";
import { logger } from "@/Logger";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface StationFilterTabProps {
    predefinedFilter: any;
    setTmpFilter: any;
    setTmpRegionFilter: any;
    viewData: any;
}

const useStyles = makeStyles()(() => ({
    tabBar: {
        backgroundColor: "white",
    },

    checkboxAllLabel: {
        fontWeight: 700,
    },

    formControl: {
        width: "100%",
    },
}));

const StationFilterTab: FunctionComponent<StationFilterTabProps> = ({
                                                                        predefinedFilter,
                                                                        setTmpFilter,
                                                                        setTmpRegionFilter,
                                                                        viewData
                                                                    }): JSX.Element => {
    const {classes} = useStyles();
    const enabledStations = useSelector((state) =>
        selectViewerEnabledStations(state as ViewerState)
    );
    const stations = viewData?.stationList?.stations?.filter((station) => station?.stationId != "FRE");

    const allAvailableRegions = viewData?.regionList?.regions;

    const availableRegionsByUser = useSelector((state) =>
        selectViewerEnabledRegions(state as ViewerState)
    );
    const regionInStorage = useAppSelector(
        (state) => state.disposition.regionFilter[0]
    );
    const [selectedRegion, setSelectedRegion] = useState(
        regionInStorage || "-1"
    );
    const {t} = useTranslation();

    logger.log(allAvailableRegions);
    logger.log(availableRegionsByUser);
    logger.log(enabledStations);

    const availableRegions = availableRegionsByUser;

    const getStationsForFilter = (regionToFilter: string) => {
        let allStations = stations;

        const allStationsEnabledForViewer: any = [];
        if (_.size(enabledStations) >= 1) {
            for (const index in enabledStations) {
                allStationsEnabledForViewer.push(
                    enabledStations[index].stationId
                );
            }
        } else {
            for (const index in allStations) {
                allStationsEnabledForViewer.push(allStations[index].stationId);
            }
        }

        allStations = allStations.filter(function (
            value: any,
        ) {
            return allStationsEnabledForViewer.indexOf(value.stationId) > -1;
        });

        const allStationsForSelectedRegion: any = [];
        let regionIndex = regionToFilter;
        for (const index in availableRegions) {
            const region = availableRegions[index];
            if (region.regionId === regionToFilter) {
                regionIndex = index;
            }
        }
        if (regionIndex !== "-1") {
            const enabledStationsInRegion =
                availableRegions[regionIndex]?.regions[0]?.enabledStations || [];
            for (const index in enabledStationsInRegion) {
                allStationsForSelectedRegion.push(
                    enabledStationsInRegion[index].stationId
                );
            }
        } else {
            for (const index in allStations) {
                allStationsForSelectedRegion.push(allStations[index].stationId);
            }
        }
        return allStations.filter(function (
            value: any,
            index: number,
            arr: any
        ) {
            return (
                allStationsEnabledForViewer.indexOf(value.stationId) > -1 &&
                allStationsForSelectedRegion.indexOf(value.stationId) > -1
            );
        });
    };

    const stationsForFilter = getStationsForFilter(selectedRegion);

    const handleDropdownChange = (event: any) => {
        let selectedStations = [];
        const tmpFilter = [];
        selectedStations = getStationsForFilter(event.target.value);
        for (const index in selectedStations) {
            tmpFilter.push(selectedStations[index].stationId);
        }
        setTmpFilter(tmpFilter);
        setSelectedRegion(event.target.value);
        setTmpRegionFilter([event.target.value]);
    };

    const handleCheckboxChange = (event: any) => {
        let tmpFilter = predefinedFilter.slice();
        if (event.target.checked) {
            if (event.target.value === "%") {
                tmpFilter = [];
                tmpFilter.push("%");
                for (const index in stationsForFilter) {
                    tmpFilter.push(stationsForFilter[index].stationId);
                }
            } else {
                if (tmpFilter.indexOf("%") > -1) {
                    tmpFilter = [];
                }
                tmpFilter.push(event.target.value);
            }
            setTmpFilter(tmpFilter);
        } else {
            if (event.target.value === "%") {
                tmpFilter = [];
            } else {
                tmpFilter = tmpFilter.filter(function (
                    value: string,
                ) {
                    return value !== event.target.value;
                });
            }
            setTmpFilter(tmpFilter);
        }
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <FormControl
                    variant="outlined"
                    margin="dense"
                    className={classes.formControl}
                >
                    <InputLabel>{t("disposition.filter.region")}</InputLabel>
                    <MuiSelect
                        size={"small"}
                        label={"Regionen"}
                        onChange={handleDropdownChange}
                        value={selectedRegion}
                    >
                        <MenuItem value="-1">
                            <em>{t("disposition.filter.allRegions")}</em>
                        </MenuItem>
                        {availableRegions.map((item: any) => (
                            <MenuItem key={item.regionId} value={item.regionId}>
                                {item.regionId}
                            </MenuItem>
                        ))}
                    </MuiSelect>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Tooltip
                    title={t("disposition.controls.tooltip.selectAllStations")}
                >
                    <Button
                        variant={"outlined"}
                        color={"secondary"}
                        size={"small"}
                        onClick={() => {
                            const tmpFilter = [];
                            let regionIndex = "-1";
                            for (const index in availableRegions) {
                                const region = availableRegions[index];
                                if (region.region === selectedRegion) {
                                    regionIndex = index;
                                }
                            }
                            if (regionIndex == "-1") {
                                for (const index in stationsForFilter) {
                                    tmpFilter.push(
                                        stationsForFilter[index].stationId
                                    );
                                }
                            } else {
                                const enabledStationsInRegion =
                                    availableRegions[regionIndex]
                                        ?.enabledStations || [];

                                for (const idx in enabledStationsInRegion) {
                                    tmpFilter.push(
                                        enabledStationsInRegion[idx].stationId
                                    );
                                }
                            }

                            setTmpFilter(tmpFilter);
                        }}
                    >
                        {t("disposition.controls.modal.selectAll")}
                    </Button>
                </Tooltip>{" "}
                <Tooltip
                    title={t(
                        "disposition.controls.tooltip.deselectAllStations"
                    )}
                >
                    <Button
                        variant={"outlined"}
                        color={"secondary"}
                        size={"small"}
                        onClick={() => {
                            setTmpFilter([]);
                        }}
                    >
                        {t("disposition.controls.modal.deselectAll")}
                    </Button>
                </Tooltip>
            </Grid>
            {stationsForFilter.map((station: any) => (
                <Grid item key={station.stationId} xs={4}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="checkedB"
                                color="secondary"
                                value={station.stationId}
                                onChange={handleCheckboxChange}
                                checked={
                                    predefinedFilter.indexOf(
                                        station.stationId
                                    ) > -1
                                }
                            />
                        }
                        label={station.stationId + " - " + station.name}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default StationFilterTab;
